/**
 * Student Projects Configuration
 *
 * Projects are compilations of sentences from multiple lessons/pages.
 * Students complete all sentences in a project as a larger assignment.
 *
 * When adding a new project, update BOTH this file AND backend/features/lessons/data/projectsConfig.js.
 * backend/__tests__/critical-flows.test.js will fail if they diverge.
 */

import { findLesson } from './lessonsRegistry.js';
import { getSentenceItems } from './itemsHelper.js';
import { normalizeCourseId } from '../utils/courseNormalization.js';

export const projectsConfig = {
  // Project ID -> Project definition
  'southstreet-b3-project1': {
    id: 'southstreet-b3-project1',
    name: 'South Street B3 Project 1',
    displayName: 'South Street Book 3 综合练习',
    topic: 'southstreet',
    batch: 'b3',
    // Pages/lessons to include (in order)
    pages: ['001', '002', '003', '005', '006', '007'],
    // No reviews for projects
    hasReviews: false,
  },
  'southstreet-b3-p1': {
    id: 'southstreet-b3-p1',
    name: 'South Street B3 Project 1',
    displayName: 'South Street Book 3 综合练习: 第1-5课',
    topic: 'southstreet',
    batch: 'b3',
    pages: ['001', '002', '003', '005'],
    hasReviews: false,
  },
  'southstreet-b3-p2': {
    id: 'southstreet-b3-p2',
    name: 'South Street B3 Project 2',
    displayName: 'South Street Book 3 综合练习: 第6-11课',
    topic: 'southstreet',
    batch: 'b3',
    pages: ['006', '007', '009', '010', '011'],
    hasReviews: false,
  },
  'southstreet-b3-p3': {
    id: 'southstreet-b3-p3',
    name: 'South Street B3 Project 3',
    displayName: 'South Street Book 3 综合练习: 第12-18课',
    topic: 'southstreet',
    batch: 'b3',
    pages: ['012', '014', '015', '017', '018'],
    hasReviews: false,
  },
  'southstreet-b3-p4': {
    id: 'southstreet-b3-p4',
    name: 'South Street B3 Project 4',
    displayName: 'South Street Book 3 综合练习: 第19-25课',
    topic: 'southstreet',
    batch: 'b3',
    pages: ['019', '021', '022', '023', '025'],
    hasReviews: false,
  },
  'southstreet-b3-p5': {
    id: 'southstreet-b3-p5',
    name: 'South Street B3 Project 5',
    displayName: 'South Street Book 3 综合练习: 第26-32课',
    topic: 'southstreet',
    batch: 'b3',
    pages: ['026', '028', '029', '030', '032'],
    hasReviews: false,
  },
  'southstreet-b3-p6': {
    id: 'southstreet-b3-p6',
    name: 'South Street B3 Project 6',
    displayName: 'South Street Book 3 综合练习: 第33-38课',
    topic: 'southstreet',
    batch: 'b3',
    pages: ['033', '035', '036', '037', '038'],
    hasReviews: false,
  },
  'southstreet-b3-p7': {
    id: 'southstreet-b3-p7',
    name: 'South Street B3 Project 7',
    displayName: 'South Street Book 3 综合练习: 第40-45课',
    topic: 'southstreet',
    batch: 'b3',
    pages: ['040', '041', '042', '044', '045'],
    hasReviews: false,
  },
  'southstreet-b3-p8': {
    id: 'southstreet-b3-p8',
    name: 'South Street B3 Project 8',
    displayName: 'South Street Book 3 综合练习: 第46-51课',
    topic: 'southstreet',
    batch: 'b3',
    pages: ['046', '047', '048', '049', '051'],
    hasReviews: false,
  },
  'southstreet-b3-p9': {
    id: 'southstreet-b3-p9',
    name: 'South Street B3 Project 9',
    displayName: 'South Street Book 3 综合练习: 第52-58课',
    topic: 'southstreet',
    batch: 'b3',
    pages: ['052', '053', '055', '056', '057', '058'],
    hasReviews: false,
  },
  'monkeyking-b2-wukong-vs-erlang': {
    id: 'monkeyking-b2-wukong-vs-erlang',
    name: 'Monkey King B2 — Wukong vs Erlang',
    displayName: '西游记 Book 2: 大战二郎神',
    topic: 'monkeyking',
    batch: 'b2',
    pages: ['004', '005', '006', '007', '008', '009', '010', '011', '012', '013', '014', '015'],
    hasReviews: false,
  },
  'monkeyking-b2-p16-19': {
    id: 'monkeyking-b2-p16-19',
    name: 'Monkey King B2 — Pages 16-19',
    displayName: '西游记 Book 2: 第74-77课',
    topic: 'monkeyking',
    batch: 'b2',
    pages: ['016', '017', '018', '019'],
    hasReviews: false,
  },
  'monkeyking-b2-p19-29': {
    id: 'monkeyking-b2-p19-29',
    name: 'Monkey King B2 — Pages 19-29',
    displayName: '西游记 Book 2: 第77-87课',
    topic: 'monkeyking',
    batch: 'b2',
    pages: ['019', '020', '021', '022', '023', '024', '025', '026', '027', '028', '029'],
    hasReviews: false,
  },
  'monkeyking-b2-p20-23': {
    id: 'monkeyking-b2-p20-23',
    name: 'Monkey King B2 — Pages 20-23',
    displayName: '西游记 Book 2: 第78-81课',
    topic: 'monkeyking',
    batch: 'b2',
    pages: ['020', '021', '022', '023'],
    hasReviews: false,
  },
  'monkeyking-b2-p24-27': {
    id: 'monkeyking-b2-p24-27',
    name: 'Monkey King B2 — Pages 24-27',
    displayName: '西游记 Book 2: 第82-85课',
    topic: 'monkeyking',
    batch: 'b2',
    pages: ['024', '025', '026', '027'],
    hasReviews: false,
  },
  'monkeyking-b2-p28-31': {
    id: 'monkeyking-b2-p28-31',
    name: 'Monkey King B2 — Pages 28-31',
    displayName: '西游记 Book 2: 第86-89课',
    topic: 'monkeyking',
    batch: 'b2',
    pages: ['028', '029', '030', '031'],
    hasReviews: false,
  },
  'monkeyking-b2-p32-35': {
    id: 'monkeyking-b2-p32-35',
    name: 'Monkey King B2 — Pages 32-35',
    displayName: '西游记 Book 2: 第90-93课',
    topic: 'monkeyking',
    batch: 'b2',
    pages: ['032', '033', '034', '035'],
    hasReviews: false,
  },
  'monkeyking-b2-p36-39': {
    id: 'monkeyking-b2-p36-39',
    name: 'Monkey King B2 — Pages 36-39',
    displayName: '西游记 Book 2: 第94-97课',
    topic: 'monkeyking',
    batch: 'b2',
    pages: ['036', '037', '038', '039'],
    hasReviews: false,
  },
  'monkeyking-b2-p40-43': {
    id: 'monkeyking-b2-p40-43',
    name: 'Monkey King B2 — Pages 40-43',
    displayName: '西游记 Book 2: 第98-101课',
    topic: 'monkeyking',
    batch: 'b2',
    pages: ['040', '041', '042', '043'],
    hasReviews: false,
  },
  'monkeyking-b2-p44-47': {
    id: 'monkeyking-b2-p44-47',
    name: 'Monkey King B2 — Pages 44-47',
    displayName: '西游记 Book 2: 第102-105课',
    topic: 'monkeyking',
    batch: 'b2',
    pages: ['044', '045', '046', '047'],
    hasReviews: false,
  },
  'monkeyking-b2-p48-51': {
    id: 'monkeyking-b2-p48-51',
    name: 'Monkey King B2 — Pages 48-51',
    displayName: '西游记 Book 2: 第106-109课',
    topic: 'monkeyking',
    batch: 'b2',
    pages: ['048', '049', '050', '051'],
    hasReviews: false,
  },
  'monkeyking-b2-p52-53': {
    id: 'monkeyking-b2-p52-53',
    name: 'Monkey King B2 — Pages 52-53',
    displayName: '西游记 Book 2: 第110-111课',
    topic: 'monkeyking',
    batch: 'b2',
    pages: ['052', '053'],
    hasReviews: false,
  },
  'monkeyking-b3-p1-4': {
    id: 'monkeyking-b3-p1-4',
    name: 'Monkey King B3 — Pages 1-4',
    displayName: '西游记 Book 3: 第112-115课',
    topic: 'monkeyking',
    batch: 'b3',
    pages: ['001', '002', '003', '004'],
    hasReviews: false,
  },
  'monkeyking-b3-p5-9': {
    id: 'monkeyking-b3-p5-9',
    name: 'Monkey King B3 — Pages 5-9',
    displayName: '西游记 Book 3: 第116-120课',
    topic: 'monkeyking',
    batch: 'b3',
    pages: ['005', '006', '007', '008', '009'],
    hasReviews: false,
  },
  'monkeyking-b3-p10-14': {
    id: 'monkeyking-b3-p10-14',
    name: 'Monkey King B3 — Pages 10-14',
    displayName: '西游记 Book 3: 第121-125课',
    topic: 'monkeyking',
    batch: 'b3',
    pages: ['010', '011', '012', '013', '014'],
    hasReviews: false,
  },
  'monkeyking-b3-p15-19': {
    id: 'monkeyking-b3-p15-19',
    name: 'Monkey King B3 — Pages 15-19',
    displayName: '西游记 Book 3: 第126-130课',
    topic: 'monkeyking',
    batch: 'b3',
    pages: ['015', '016', '017', '018', '019'],
    hasReviews: false,
  },
  'monkeyking-b3-p20-24': {
    id: 'monkeyking-b3-p20-24',
    name: 'Monkey King B3 — Pages 20-24',
    displayName: '西游记 Book 3: 第131-135课',
    topic: 'monkeyking',
    batch: 'b3',
    pages: ['020', '021', '022', '023', '024'],
    hasReviews: false,
  },
  'monkeyking-b3-p25-29': {
    id: 'monkeyking-b3-p25-29',
    name: 'Monkey King B3 — Pages 25-29',
    displayName: '西游记 Book 3: 第136-140课',
    topic: 'monkeyking',
    batch: 'b3',
    pages: ['025', '026', '027', '028', '029'],
    hasReviews: false,
  },
  'monkeyking-b3-p30-34': {
    id: 'monkeyking-b3-p30-34',
    name: 'Monkey King B3 — Pages 30-34',
    displayName: '西游记 Book 3: 第141-145课',
    topic: 'monkeyking',
    batch: 'b3',
    pages: ['030', '031', '032', '033', '034'],
    hasReviews: false,
  },
  'monkeyking-b3-p35-39': {
    id: 'monkeyking-b3-p35-39',
    name: 'Monkey King B3 — Pages 35-39',
    displayName: '西游记 Book 3: 第146-150课',
    topic: 'monkeyking',
    batch: 'b3',
    pages: ['035', '036', '037', '038', '039'],
    hasReviews: false,
  },
  'monkeyking-b3-p40-44': {
    id: 'monkeyking-b3-p40-44',
    name: 'Monkey King B3 — Pages 40-44',
    displayName: '西游记 Book 3: 第151-155课',
    topic: 'monkeyking',
    batch: 'b3',
    pages: ['040', '041', '042', '043', '044'],
    hasReviews: false,
  },
  'monkeyking-b3-p45-49': {
    id: 'monkeyking-b3-p45-49',
    name: 'Monkey King B3 — Pages 45-49',
    displayName: '西游记 Book 3: 第156-160课',
    topic: 'monkeyking',
    batch: 'b3',
    pages: ['045', '046', '047', '048', '049'],
    hasReviews: false,
  },
  'monkeyking-b3-p50-54': {
    id: 'monkeyking-b3-p50-54',
    name: 'Monkey King B3 — Pages 50-54',
    displayName: '西游记 Book 3: 第161-165课',
    topic: 'monkeyking',
    batch: 'b3',
    pages: ['050', '051', '052', '053', '054'],
    hasReviews: false,
  },
  'monkeyking-b3-p55-59': {
    id: 'monkeyking-b3-p55-59',
    name: 'Monkey King B3 — Pages 55-59',
    displayName: '西游记 Book 3: 第166-170课',
    topic: 'monkeyking',
    batch: 'b3',
    pages: ['055', '056', '057', '058', '059'],
    hasReviews: false,
  },
  'monkeyking-b3-p60-65': {
    id: 'monkeyking-b3-p60-65',
    name: 'Monkey King B3 — Pages 60-65',
    displayName: '西游记 Book 3: 第171-176课',
    topic: 'monkeyking',
    batch: 'b3',
    pages: ['060', '061', '062', '063', '064', '065'],
    hasReviews: false,
  },
  'monkeyking-b3-p37-48': {
    id: 'monkeyking-b3-p37-48',
    name: 'Monkey King B3 — Pages 37-48',
    displayName: '西游记 Book 3: 第148-159课',
    topic: 'monkeyking',
    batch: 'b3',
    pages: ['037', '038', '039', '040', '041', '042', '043', '044', '045', '046', '047', '048'],
    hasReviews: false,
  },
  // Mkk b4 (class 30, from 2026-10-11): blocks 1-4, then 5s; the leftover lessons join the last block.
  'monkeyking-b4-p1-4': {
    id: 'monkeyking-b4-p1-4',
    name: 'Monkey King B4 — Pages 1-4',
    displayName: '西游记 Book 4: 第177-180课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['001', '002', '003', '004'],
    hasReviews: false,
  },
  'monkeyking-b4-p5-9': {
    id: 'monkeyking-b4-p5-9',
    name: 'Monkey King B4 — Pages 5-9',
    displayName: '西游记 Book 4: 第181-185课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['005', '006', '007', '008', '009'],
    hasReviews: false,
  },
  'monkeyking-b4-p10-14': {
    id: 'monkeyking-b4-p10-14',
    name: 'Monkey King B4 — Pages 10-14',
    displayName: '西游记 Book 4: 第186-190课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['010', '011', '012', '013', '014'],
    hasReviews: false,
  },
  'monkeyking-b4-p15-19': {
    id: 'monkeyking-b4-p15-19',
    name: 'Monkey King B4 — Pages 15-19',
    displayName: '西游记 Book 4: 第191-195课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['015', '016', '017', '018', '019'],
    hasReviews: false,
  },
  'monkeyking-b4-p20-24': {
    id: 'monkeyking-b4-p20-24',
    name: 'Monkey King B4 — Pages 20-24',
    displayName: '西游记 Book 4: 第196-200课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['020', '021', '022', '023', '024'],
    hasReviews: false,
  },
  'monkeyking-b4-p25-29': {
    id: 'monkeyking-b4-p25-29',
    name: 'Monkey King B4 — Pages 25-29',
    displayName: '西游记 Book 4: 第201-205课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['025', '026', '027', '028', '029'],
    hasReviews: false,
  },
  'monkeyking-b4-p30-34': {
    id: 'monkeyking-b4-p30-34',
    name: 'Monkey King B4 — Pages 30-34',
    displayName: '西游记 Book 4: 第206-210课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['030', '031', '032', '033', '034'],
    hasReviews: false,
  },
  'monkeyking-b4-p35-39': {
    id: 'monkeyking-b4-p35-39',
    name: 'Monkey King B4 — Pages 35-39',
    displayName: '西游记 Book 4: 第211-215课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['035', '036', '037', '038', '039'],
    hasReviews: false,
  },
  'monkeyking-b4-p40-44': {
    id: 'monkeyking-b4-p40-44',
    name: 'Monkey King B4 — Pages 40-44',
    displayName: '西游记 Book 4: 第216-220课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['040', '041', '042', '043', '044'],
    hasReviews: false,
  },
  'monkeyking-b4-p45-49': {
    id: 'monkeyking-b4-p45-49',
    name: 'Monkey King B4 — Pages 45-49',
    displayName: '西游记 Book 4: 第221-225课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['045', '046', '047', '048', '049'],
    hasReviews: false,
  },
  'monkeyking-b4-p50-54': {
    id: 'monkeyking-b4-p50-54',
    name: 'Monkey King B4 — Pages 50-54',
    displayName: '西游记 Book 4: 第226-230课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['050', '051', '052', '053', '054'],
    hasReviews: false,
  },
  'monkeyking-b4-p55-59': {
    id: 'monkeyking-b4-p55-59',
    name: 'Monkey King B4 — Pages 55-59',
    displayName: '西游记 Book 4: 第231-235课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['055', '056', '057', '058', '059'],
    hasReviews: false,
  },
  'monkeyking-b4-p60-64': {
    id: 'monkeyking-b4-p60-64',
    name: 'Monkey King B4 — Pages 60-64',
    displayName: '西游记 Book 4: 第236-240课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['060', '061', '062', '063', '064'],
    hasReviews: false,
  },
  'monkeyking-b4-p65-69': {
    id: 'monkeyking-b4-p65-69',
    name: 'Monkey King B4 — Pages 65-69',
    displayName: '西游记 Book 4: 第241-245课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['065', '066', '067', '068', '069'],
    hasReviews: false,
  },
  'monkeyking-b4-p70-74': {
    id: 'monkeyking-b4-p70-74',
    name: 'Monkey King B4 — Pages 70-74',
    displayName: '西游记 Book 4: 第246-250课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['070', '071', '072', '073', '074'],
    hasReviews: false,
  },
  'monkeyking-b4-p75-81': {
    id: 'monkeyking-b4-p75-81',
    name: 'Monkey King B4 — Pages 75-81',
    displayName: '西游记 Book 4: 第251-257课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['075', '076', '077', '078', '079', '080', '081'],
    hasReviews: false,
  },
};

/**
 * Get project config by ID
 * @param {string} projectId
 * @returns {object|null}
 */
export const getProjectConfig = (projectId) => {
  return projectsConfig[projectId] || null;
};

/**
 * Get all projects for a topic/batch
 * @param {string} topic
 * @param {string} batch
 * @returns {object[]}
 */
export const getProjectsForBatch = (topic, batch) => {
  return Object.values(projectsConfig).filter(
    p => p.topic === topic && p.batch === batch
  );
};

/**
 * Get all sentences for a project, combined from all pages
 * Uses the unified lesson config for correct video timestamps
 * Each sentence gets a unique projectSentenceId for submission tracking
 * @param {string} projectId
 * @returns {Promise<object[]>} Array of sentences with page info
 */
export const getProjectSentences = async (projectId) => {
  const project = getProjectConfig(projectId);
  if (!project) return [];

  // Normalize topic name (handle course aliases)
  const normalizedTopic = normalizeCourseId(project.topic) || project.topic;

  const allSentences = [];
  let globalIndex = 1;

  // Collect sentences from each lesson/page in order
  for (const lessonNumber of project.pages) {
    // Find the lesson in the unified registry (async)
    const lesson = await findLesson(normalizedTopic, project.batch, lessonNumber);
    if (!lesson) continue;

    // Get sentence items from the lesson using the helper
    const sentenceItems = getSentenceItems(lesson);
    if (!sentenceItems?.length) continue;

    for (const sentence of sentenceItems) {
      allSentences.push({
        ...sentence,
        // 's'-prefixed, like every other item-id producer — see canonicalSentenceId
        // in src/utils/itemTypes.js. Was a BARE index ("17") until 2026-08-18;
        // history is backfilled by canonicalizeBareItemIds in backend/database/migrations.js.
        // Still a string: submission.sentenceId is TEXT, and numeric coercion breaks
        // the completedRecordings[item.id] lookup.
        id: `s${globalIndex}`,
        originalPage: lessonNumber,
        originalId: sentence.id,
        pageLabel: `Page ${parseInt(lessonNumber, 10)}`,
        type: 'sentence',
        repeats: sentence.repeats || 3,
      });
      globalIndex++;
    }
  }

  return allSentences;
};

/**
 * Get total sentence count for a project
 * @param {string} projectId
 * @returns {Promise<number>}
 */
export const getProjectSentenceCount = async (projectId) => {
  const sentences = await getProjectSentences(projectId);
  return sentences.length;
};

/**
 * Get ordered array of unique video configs for a project (one per distinct HLS URL).
 * Each entry includes startAt/endAt — the first/last sentence timestamps for that episode —
 * so the player can skip intros and outros when auto-advancing between episodes.
 * @param {string} projectId
 * @returns {Promise<Array<{hls: string, thumb: string, startAt: number, endAt: number}>>}
 */
export const getProjectVideos = async (projectId) => {
  const project = getProjectConfig(projectId);
  if (!project?.pages?.length) return [];
  const normalizedTopic = normalizeCourseId(project.topic) || project.topic;
  const seen = new Map(); // hls → { hls, thumb, startAt, endAt }

  for (const lessonNumber of project.pages) {
    const lesson = await findLesson(normalizedTopic, project.batch, lessonNumber);
    if (!lesson?.videos?.sentences) continue;
    const { hls, thumb } = lesson.videos.sentences;
    if (!hls) continue;
    const sentences = getSentenceItems(lesson);
    if (!sentences?.length) continue;
    if (!seen.has(hls)) {
      seen.set(hls, { hls, thumb, startAt: sentences[0].videoStart, endAt: sentences[sentences.length - 1].videoEnd });
    } else {
      seen.get(hls).endAt = sentences[sentences.length - 1].videoEnd;
    }
  }
  return [...seen.values()];
};

/**
 * Get the sentences video for a project
 * Uses the first page's lesson to get the video URL
 * @param {string} projectId
 * @returns {Promise<object|null>} { hls, thumb } or null
 */
export const getProjectVideo = async (projectId) => {
  const project = getProjectConfig(projectId);
  if (!project || !project.pages?.length) return null;

  // Get the first page's lesson number
  const firstPage = project.pages[0];
  const normalizedTopic = normalizeCourseId(project.topic) || project.topic;

  // Find the lesson in the registry (async)
  const lesson = await findLesson(normalizedTopic, project.batch, firstPage);
  if (!lesson?.videos?.sentences) return null;

  return lesson.videos.sentences;
};
